/* @flow */

import { object, string, boolean } from "yup";

export const lesserVolumeError = "Lesser volume";
export const emailError = "Please enter a valid email";
export const requiredError = "This field is required";
export const requiredCountryError = "Please select an option from the list";
export const numberError = "Sorry, only numbers (0-9) are allowed";

export default object().shape({
  firstName: string().required(requiredError),
  lastName: string().required(requiredError),
  companyName: string().required(requiredError),
  businessLocation: object()
    .shape({ text: string().required(requiredError), key: string() })
    .required(requiredError),
  emailAddress: string()
    .email(emailError)
    .required(requiredError),
  consent: boolean().oneOf([true], requiredError)
});
